var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from "react";
import layoutComponentsDictionary from "../layoutComponentsDictionary";
import { FormSettingsContext } from "../../utils";
import Input from "@mui/joy/Input";
import { Spacing } from "../../properties/spacing";
import { Color } from "../../properties/color";
import copy from "fast-copy";
/**
 * Settings of TAB
 *
 * @param moduleName
 * @param layoutName
 * @param packageName
 */
export function TabSettings(_a) {
    var moduleName = _a.moduleName, layoutName = _a.layoutName, packageName = _a.packageName;
    var _b = useContext(FormSettingsContext), settings = _b.settings, editedSettings = _b.editedSettings;
    var current = settings.currentComponent || {};
    var s = current.settings || {};
    var labels = s.labels || [];
    var _c = useState(copy(labels)), labelValue = _c[0], setLabelValue = _c[1];
    // Ajouter un tab
    var addTab = function () {
        var editedValue = copy(current);
        var s = editedValue.settings || {};
        var labels = s.labels || [];
        labels.push("");
        var components = editedValue.components || [];
        var uuidv4 = require("uuid").v4;
        var id = uuidv4();
        var newComponent = {
            id: id,
            type: "layout-rows",
            components: [],
        };
        s.labels = labels;
        editedValue.settings = s;
        editedValue.components = components;
        setLabelValue(labels);
        editedSettings(__assign(__assign({}, settings), { selected: id, component: {
                settings: s,
                components: newComponent,
            }, isNew: false }));
    };
    // Supprimer un tab
    var removeTab = function (index) {
        var editedValue = current;
        var s = editedValue.settings || {};
        var labels = s.labels || [];
        var components = editedValue.components || [];
        // eslint-disable-next-line no-restricted-globals
        var remove = confirm("Voulez-vous vraiment supprimer l'onglet ".concat(labels[index], "?"));
        if (remove) {
            labels.splice(index, 1);
            components.splice(index, 1);
            editedSettings(__assign(__assign({}, settings), { component: {
                    settings: __assign(__assign({}, settings), { labels: labels }),
                    components: { components: components },
                }, isDirty: true }));
        }
        setLabelValue(labels);
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "p-4 pb-16" }, { children: [_jsxs("div", { children: [_jsx("label", { children: "Titre(s) de(s) onglet(s) " }), settings.target !== 0 ? (_jsxs("div", { children: [labelValue.length > 0 && (_jsx("ul", { children: labelValue.map(function (item, index) { return (_jsxs("li", __assign({ className: "flex flex-row" }, { children: [_jsx(Input, { type: "text", size: "sm", autoFocus: true, name: index, defaultValue: labels[index], onChange: function (event) {
                                                    var newLabels = copy(labels);
                                                    newLabels[event.target.name] = event.target.value;
                                                    editedSettings(__assign(__assign({}, settings), { currentComponent: {
                                                            settings: {
                                                                labels: newLabels,
                                                            },
                                                        }, isDirty: true }));
                                                } }), _jsx("button", __assign({ title: "Supprimer l'onglet", className: "bouton", onClick: function () {
                                                    removeTab(index);
                                                } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" }) })) }))] }), index)); }) })), _jsx("button", __assign({ className: "bouton", title: "Ajout un onglet", onClick: function (e) {
                                        e.stopPropagation();
                                        addTab();
                                    } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" }) })) }))] })) : (_jsx("div", { children: _jsx("button", __assign({ className: "bouton", title: "Ajout un onglet", onClick: function () {
                                    addTab();
                                } }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" }) })) })) }))] }), _jsx(Spacing, {}), _jsx(Color, {})] })) }));
}
layoutComponentsDictionary.registerLayoutComponent("tab-settings", TabSettings);
